(function() {
  'use strict';

  function formatCentsWithCurrency(cents, template) {
    const num = cents / 100;
    const formatted = num % 1 === 0 ? num.toString() : num.toFixed(2);
    if (!template) return formatted;
    const prefix = String(template).match(/^[^\d.,]+/);
    const suffix = String(template).match(/[^\d.,]+$/);
    return (prefix ? prefix[0] : '') + formatted + (suffix ? suffix[0] : '');
  }

  /** Third-party scripts (e.g. Affirm) sometimes inject <p> nodes inside swatch options; strip them. */
  function removeParagraphsFromSwatchOptions(container) {
    container.querySelectorAll('.nw-product-swatch__option').forEach(function(option) {
      option.querySelectorAll('p').forEach(function(p) {
        p.remove();
      });
    });
  }

  function attachSwatchOptionParagraphObserver(container) {
    if (container._nwSwatchParagraphObserver) return;
    const observer = new MutationObserver(function() {
      removeParagraphsFromSwatchOptions(container);
    });
    observer.observe(container, { childList: true, subtree: true });
    container._nwSwatchParagraphObserver = observer;
  }

  function updateProductFromSwatch(checkedRadio) {
    if (!checkedRadio) return;

    const variantId = checkedRadio.value;
    const price = checkedRadio.getAttribute('data-price');
    const comparePrice = checkedRadio.getAttribute('data-compare-price');
    const saveAmount = checkedRadio.getAttribute('data-save-amount');
    const productEl = checkedRadio.closest('.product');
    if (!productEl) return;

    const swatchContainer = checkedRadio.closest('.nw-product-swatch');
    const swatchRadios = swatchContainer ? swatchContainer.querySelectorAll('input[name="nw-product-swatch"]') : [];
    const selectedIndex = Array.from(swatchRadios).indexOf(checkedRadio);
    document.querySelectorAll('[data-dynamic-save-prices]').forEach(function(pricesBlock) {
      let productPriceCents = 0;
      try {
        const pricesArr = JSON.parse(pricesBlock.getAttribute('data-dynamic-save-prices') || '[]');
        productPriceCents = parseInt(pricesArr[selectedIndex], 10) || parseInt(pricesArr[0], 10) || 0;
      } catch (e) {}
      const singlePriceEl = pricesBlock.querySelector('[data-dynamic-single-price]');
      const singlePriceFormatTemplate = singlePriceEl ? singlePriceEl.getAttribute('data-dynamic-single-price') : null;
      const singlePriceDisplayValue = formatCentsWithCurrency(productPriceCents, singlePriceFormatTemplate);
      if (singlePriceEl) singlePriceEl.textContent = singlePriceDisplayValue;
      let saveDisplayValue = '';
      try {
        const saveValuesArr = JSON.parse(pricesBlock.getAttribute('data-dynamic-save-values') || '[]');
        saveDisplayValue = (saveValuesArr[selectedIndex] || saveValuesArr[0] || '').toString().trim();
      } catch (e) {}
      const saveEl = pricesBlock.querySelector('[data-dynamic-save-value]');
      const saveWrapper = pricesBlock.querySelector('[data-dynamic-save-wrapper]');
      if (saveEl) saveEl.textContent = saveDisplayValue;
      if (saveWrapper) saveWrapper.style.display = saveDisplayValue ? '' : 'none';
    });

    // 1. Update variant ID in add-to-cart form
    const cartForm = productEl.querySelector('form[action*="cart/add"].shopify-product-form') ||
      productEl.querySelector('form[action*="cart/add"]') ||
      productEl.querySelector('.product-form form');
    if (cartForm) {
      const idInput = cartForm.querySelector('input[name="id"], select[name="id"]');
      if (idInput) {
        idInput.value = variantId;
        if (idInput.tagName === 'SELECT') {
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // 2. Update variant ID in payment terms form and trigger change
    const paymentTermsForm = productEl.querySelector('form[data-payment-terms-target]');
    if (paymentTermsForm) {
      let paymentTermsIdInput = paymentTermsForm.querySelector('input[name="id"]');
      if (!paymentTermsIdInput) {
        paymentTermsIdInput = document.createElement('input');
        paymentTermsIdInput.type = 'hidden';
        paymentTermsIdInput.name = 'id';
        paymentTermsForm.appendChild(paymentTermsIdInput);
      }
      paymentTermsIdInput.value = variantId;
      paymentTermsIdInput.dispatchEvent(new Event('input', { bubbles: true }));
      paymentTermsIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 3. Update price display
    const productPriceEl = productEl.querySelector('.product-price');
    if (productPriceEl && price !== null) {
      const priceEl = productPriceEl.querySelector('.money:not(.original)');
      if (priceEl) {
        priceEl.textContent = price;
      }
    }

    if (productPriceEl && comparePrice !== null && comparePrice !== '') {
      const comparePriceEl = productPriceEl.querySelector('.original.money');
      if (comparePriceEl) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.classList.remove('hidden');
      }
    } else if (productPriceEl) {
      const comparePriceEl = productPriceEl.querySelector('.original.money');
      if (comparePriceEl) {
        comparePriceEl.classList.add('hidden');
      }
    }

    if (productPriceEl && saveAmount !== null && saveAmount !== '') {
      const savePriceEl = productPriceEl.querySelector('.save-price');
      if (savePriceEl) {
        savePriceEl.textContent = 'Save ' + saveAmount + ' Today';
        savePriceEl.style.display = '';
      }
    } else if (productPriceEl) {
      const savePriceEl = productPriceEl.querySelector('.save-price');
      if (savePriceEl) {
        savePriceEl.style.display = 'none';
      }
    }

    // 4. Toggle product-gallery--active based on selected variant
    const swatchGalleries = productEl.querySelectorAll('[data-swatch-gallery="true"]');
    swatchGalleries.forEach(function(gallery) {
      const galleryVariantId = gallery.getAttribute('data-swatch-gallery-id');
      if (galleryVariantId === variantId) {
        gallery.classList.add('product-gallery--active');
      } else {
        gallery.classList.remove('product-gallery--active');
      }
    });
  }

  function initProductSwatch() {
    const swatchContainers = document.querySelectorAll('.nw-product-swatch');
    swatchContainers.forEach(function(container) {
      const radios = container.querySelectorAll('input[name="nw-product-swatch"]');
      if (radios.length === 0) return;

      removeParagraphsFromSwatchOptions(container);
      attachSwatchOptionParagraphObserver(container);

      // Run on load for the initially checked option
      const checkedRadio = container.querySelector('input[name="nw-product-swatch"]:checked');
      if (checkedRadio) {
        updateProductFromSwatch(checkedRadio);
      }

      // Listen for change events
      container.addEventListener('change', function(e) {
        if (e.target.name === 'nw-product-swatch' && e.target.checked) {
          updateProductFromSwatch(e.target);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSwatch);
  } else {
    initProductSwatch();
  }

  // Re-init for Shopify theme editor / section re-renders
  document.addEventListener('shopify:section:load', initProductSwatch);
})();
